import { getQuery, parseURL } from 'ufo'
import { HttpErrorService } from '~/services/HttpError.service'
import { pageKitErrorHandbook } from '~/models/Errors'
import type { PageKit } from '~~/models'
import { HttpService } from '~/services/Http.service'

export class PageKitService {
  private httpErrorService: HttpErrorService<keyof typeof pageKitErrorHandbook>
  private endpoint = '/page-kit'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      pageKitErrorHandbook,
      'page-kit',
    )
  }

  /**
   * @param urlSlug - если без хэштега, отдаем как query параметр запроса
   * @param config
   * @param needCancelAtChangeRoute
   */
  async getBySlug(
    urlSlug: number | string,
    config?: { needCancelAtChangeRoute: boolean },
  ) {
    const url = this.endpoint
    const query = getQuery(String(urlSlug))
    const { pathname } = parseURL(String(urlSlug))
    const params = urlSlug ? { slug: pathname, ...query } : {}

    return await this.httpService
      .get<PageKit>(url, {
        fetchConfig: {
          params,
        },
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: !!config?.needCancelAtChangeRoute,
          forceRequest: true,
          needGlobal404: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error)
      })
  }
}
